module.exports = __webpack_public_path__ + "img/Renault-logo-2015-2048x2048.e5f8d0eb.png";